import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
export var User = /*#__PURE__*/function (_Entity) {
  _inherits(User, _Entity);

  var _super = _createSuper(User);

  function User() {
    _classCallCheck(this, User);

    return _super.apply(this, arguments);
  }

  _createClass(User, [{
    key: "email",
    get: function get() {
      return this.props.email;
    }
  }, {
    key: "firstName",
    get: function get() {
      return this.props.firstName;
    }
  }, {
    key: "lastName",
    get: function get() {
      return this.props.lastName;
    }
  }, {
    key: "image",
    get: function get() {
      return this.props.image;
    }
  }, {
    key: "phoneNumber",
    get: function get() {
      return this.props.phoneNumber;
    }
  }, {
    key: "username",
    get: function get() {
      return this.props.username;
    }
  }, {
    key: "hasPassword",
    get: function get() {
      return this.props.hasPassword;
    }
  }, {
    key: "getProps",
    value: function getProps() {
      return _objectSpread({}, this.props);
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }, {
    key: "updateFirstName",
    value: function updateFirstName(firstName) {
      this.props.firstName = firstName;
    }
  }, {
    key: "updateLastName",
    value: function updateLastName(lastName) {
      this.props.lastName = lastName;
    }
  }, {
    key: "updatePhoneNumber",
    value: function updatePhoneNumber(phoneNumber) {
      this.props.phoneNumber = phoneNumber;
    }
  }, {
    key: "updateUsername",
    value: function updateUsername(username) {
      this.props.username = username;
    }
  }, {
    key: "isMissingInformation",
    value: function isMissingInformation() {
      return this.firstName === '' || this.lastName === '' || this.username === '';
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.email,
        argumentName: 'Email'
      }, {
        argument: props.firstName,
        argumentName: 'FirstName'
      }, {
        argument: props.username,
        argumentName: 'UserName'
      }, {
        argument: props.lastName,
        argumentName: 'LastName'
      }];
      var result = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!result.succeeded) {
        return Result.fail(result.message);
      }

      return Result.ok(new User(props, new UniqueEntityID(props.id)));
    }
  }]);

  return User;
}(Entity);